import type { FC } from "react";

const SkipToContent: FC = () => (
  <a
    href="#main-content"
    className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[100] focus:rounded focus:bg-legacy-white focus:px-4 focus:py-2 focus:text-[#1F2022] focus:shadow-lg"
  >
    Skip to content
  </a>
);

export default SkipToContent;
